import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"

import * as ItemTypes from "../../redux/items/types"
import ProcessTypes from "../../redux/processes/types"
import BundleForm from "./Form"
import ProgressOverlay from "../ProgressOverlay"

class UpdateBundle extends Component {

  componentDidMount() {
    const { setCurrentBundleId, currentBundle, loadBundles, params } = this.props
    setCurrentBundleId(params.id)
    if (!currentBundle) {
      loadBundles()
    }
  }

  render() {
    const { currentBundle, saveBundle, running, success, failed, error } = this.props

    return (
      <div>
        <ProgressOverlay visible={ running }>
          Showing bundle data...
        </ProgressOverlay>

        { !!currentBundle &&
          <BundleForm
            bundle={ currentBundle }
            onSaveClicked={data => saveBundle(currentBundle.id, data)}
            failed={ failed }
            running={ running }
            success={ success }
            error={ error }
          />
        }
      </div>
    )
  }
}

UpdateBundle.propTypes = {
  currentBundle: PropTypes.object,
  saveBundle: PropTypes.func.isRequired,
  bundleSaving: PropTypes.bool,
  bundleSaveFailed: PropTypes.bool,
  setCurrentBundleId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {

  const mapping = {

    currentBundle: DckSelectors.selectItemById(
      state,
      ItemTypes.Bundle,
      ownProps.params.id
    ),
    running: DckSelectors.selectProcessRunning(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),

    failed: DckSelectors.selectProcessFailed(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),

    success: DckSelectors.selectProcessSuccess(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),

    result: DckSelectors.selectProcess(
      state,
      ProcessTypes.BUNDLE_SAVE
    ),

    bundles: DckSelectors.selectAllItems(state, ItemTypes.Bundle)
  }

  mapping['error'] = (mapping.failed && mapping.result && mapping.result.result)
    ? mapping.result.result.message : null

  return mapping
}

const mapDispatchToProps = dispatch => ({
  setCurrentBundleId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Bundle, id)),
  saveBundle: (id, data) => dispatch(DckActionCreators.itemSave(ItemTypes.Bundle, id, data)),
  loadBundles: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Bundle))
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateBundle)



// WEBPACK FOOTER //
// ./src/components/Bundles/Update.js